// Settings shared by the client, server and edge Sentry initialisations.
//
// The environment is resolved once at build time in next.config.mjs and handed
// over as NEXT_PUBLIC_SENTRY_ENVIRONMENT, because browser code cannot read
// VERCEL_ENV at runtime — reading it there is what made every event, deployed
// ones included, show up as "local".

export const SENTRY_DSN =
  "https://b9d5a2b60f872d2431e96a98d46a744f@o4507175714357248.ingest.de.sentry.io/4510465093206096";

// "production" | "preview" on Vercel, "development" on a developer machine.
export const SENTRY_ENVIRONMENT =
  process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT || "development";

// Nothing is sent from a developer machine. To test the integration locally,
// set SENTRY_ENVIRONMENT (e.g. "local-debug") in .env.local and restart.
export const SENTRY_ENABLED = SENTRY_ENVIRONMENT !== "development";
